<script setup lang="ts">
withDefaults(defineProps<{
    align?: 'left' | 'center' | 'right';
}>(), {
    align: 'right',
});
</script>

<template>
    <p :class="[`text-${align}`, 'mb-0']">
        <nuxt-link to="/" class="btn btn-outline-primary btn-sm">
            <Icon v="home" />
            <T>home.link</T>
        </nuxt-link>
    </p>
</template>
